import React, { useState } from "react";
import { Helmet } from "react-helmet";
import MediaDisplay from "./Media_comp/MediaDisplay";
import Sidebar from './components/Sidebar';
import FullScreenImage from './components/FullScreenImage';
import mediaItems from './content/nudges.json';

function Homepage() {
    const [fullScreenMedia, setFullScreenMedia] = useState(null);

    const handleMediaClick = (item) => {
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'nudge_open', {
                nudge_id: item.id,
                nudge_title: item.title,
                media_type: item.type,
            });
        }

        setFullScreenMedia(item);
    };

  return (
    <div className="flex bg-custom_BG-100 h-screen">
    <Helmet>
        <title>UX Nudges</title>
        <meta name="description" content="Nudges are contextual hints designed to encourage users to take actions or make decisions they might not naturally choose.  This collection provides examples of" />

        <meta itemProp="name" content="UX Nudges" />
        <meta itemProp="description" content="Nudges are contextual hints designed to encourage users to take actions or make decisions they might not naturally choose.  This collection provides examples of" />
        <meta itemProp="image" content="https://firebasestorage.googleapis.com/v0/b/ux-nudge.appspot.com/o/link_preview.png?alt=media&token=77adbaa5-bb10-41c7-8895-7e3776b99136" />

        <meta property="og:url" content="https://ux-nudge.web.app/" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="UX Nudges" />
        <meta property="og:description" content="Nudges are contextual hints designed to encourage users to take actions or make decisions they might not naturally choose.  This collection provides examples of" />
        <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/ux-nudge.appspot.com/o/link_preview.png?alt=media&token=77adbaa5-bb10-41c7-8895-7e3776b99136" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="UX Nudges" />
        <meta name="twitter:description" content="Nudges are contextual hints designed to encourage users to take actions or make decisions they might not naturally choose.  This collection provides examples of" />
        <meta name="twitter:image" content="https://firebasestorage.googleapis.com/v0/b/ux-nudge.appspot.com/o/link_preview.png?alt=media&token=77adbaa5-bb10-41c7-8895-7e3776b99136" />

    </Helmet>

    {fullScreenMedia && (
        <FullScreenImage
            mediaUrl={fullScreenMedia.url}
            title={fullScreenMedia.title}
            type={fullScreenMedia.type}
            onClose={() => setFullScreenMedia(null)}
        />
    )}
      
      <Sidebar />
        <div className="flex-1 ml-[360px] overflow-y-auto scrollbar-hide">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-4 p-4">
                        {mediaItems.map((item, index) => (
                            <div 
                            className="flex flex-col min-w-[200px] max-w-[600px] w-full h-full overflow-hidden cursor-pointer" 
                            key={item.id} 
                            onClick={() => handleMediaClick(item)}
                        >
                                <MediaDisplay 
                                    src={item.url} 
                                    title={item.title}
                                    type={item.type}
                                    poster={item.poster}
                                    priority={index < 8}
                                />
                            </div>
                        ))}
                </div>
            </div>
        </div>
    );
}

export default Homepage;